module.exports = __webpack_public_path__ + "img/menu-main-closed.7172abcf.svg";